import translate from '../../translations'

export default data => {
  const str = `
    <div class="background" style="background-image: url('${
  data.imgSrc
}')"></div>
    <img class="card-lines" src="/assets/front/lines.png">

    <div class="card__inner">
        <div class="card__top">
          <a href="${data.url}">
              <h3 class="title-slice title-slice--L title-slice--white">
                  ${data.title}
              </h3>
          </a>
            <div class="mt-5 uppon-title uppon-title--S uppon-title--white">
                ${data.desc}
            </div> 

        </div>
        <div class="card__bottom">
            <a href="${
  data.url
}" class="button button-icon button--white" rel="nofollow">
                <div>
                    <svg class="icon icon-arrow-corner-down icon--red" aria-hidden="true">
                        <use href="#icon-arrow-corner-down" xlink:href="#icon-arrow-corner-down" />
                    </svg>
                    <span>${translate('DISCOVER')}</span>
                </div>
            </a>
        </div>
    </div>`

  return str
}
